import script from "./PublicLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicLayout.vue?vue&type=script&lang=ts&setup=true"

import "./PublicLayout.vue?vue&type=style&index=0&id=97e12fa4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97e12fa4"]])

export default __exports__